var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyspaceStackTransparent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "581px",
    height: "581px",
    viewBox: "-0.5 -0.5 581 581",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2021-01-30T12:41:39.554Z\" agent=\"5.0 (X11)\" etag=\"nhEuN7EmADAOXpt1BhAN\" version=\"14.2.9\" type=\"device\"><diagram id=\"yGWtwPvJ5FSRlH2z2niW\" name=\"Page-1\">zVZdb5swFP01PE4CHJfwOGiyadM0qZm0x8kBB6wYmxlTyH79rouBkIQ2mdSuT/E9vl8+594kDoqL9pMiZf5NppQ7vpu2Drp3fN9b+gv4MMihQ0JsgUyx1DqNwIb9oRZ0LVqzlFYTRy0l16ycgokUgiZ6ghGlZDN120k+rVqSjJ4Bm4Twc/QnS3XeoUvsjvhnyrK8r+y59qYgvbMFqpyksjmC0MpBsZJSd6eijSk35PW8dHHrmduhMUWFvibgV1g9/t6G5Ee1JzluvyRfg4cPNssj4bV9sG1WH3oGIAuQDUbU5EzTTUkSc9OA3oDluuBgeXAkVdkpsGMthaJRpZXc01hyqQAVUpgkO8b5CWR7oErTdvZx3kAZzBqVBdXqAC59AMJdiB0zL7CsN6NoeGmx/EiwASR2ULIh98glHCydN1AbvkxtpmRtSITh1YQJqiyTs4TYKSfbPoN7K1F+MCXKv0AUci8QhZ4jypZ7ML2JDJq7qR6+UG5xUo1wTZUgmkayFml1ps7w0n8XDL8s2NG0X1oGWPHSmKyScb2lwEu0JcneyCzS77XmzMz7Uzi4fHxiCkx8shaOj9YLtMLx3A5dtTDzQ3k+HP3W4CuHwXu1rbl7RyL4wX0Q3r25CO5/FyF4TyJ40Tr231qE11wEMMdf/e7La/zvhFZ/AQ==</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 290,
    cy: 290,
    rx: 290,
    ry: 290,
    fill: "transparent",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 290 250 L 440 322.02 L 440 357.98 L 290 430 L 140 357.98 L 140 322.02 Z",
    fill: "#f43e5c",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 140 322.02 L 290 394.05 L 440 322.02 M 290 394.05 L 290 430",
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 290 200 L 440 272.02 L 440 307.98 L 290 380 L 140 307.98 L 140 272.02 Z",
    fill: "#27d796",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 140 272.02 L 290 344.05 L 440 272.02 M 290 344.05 L 290 380",
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 290 150 L 440 222.02 L 440 257.98 L 290 330 L 140 257.98 L 140 222.02 Z",
    fill: "#21bfc2",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 140 222.02 L 290 294.05 L 440 222.02 M 290 294.05 L 290 330",
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyspaceStackTransparent);
export default __webpack_public_path__ + "static/media/keyspace-stack-transparent.036e680c2875302da4713e6d38ce333f.svg";
export { ForwardRef as ReactComponent };